"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.olapicInfoSchema = void 0;
var _zod = require("zod");
const olapicInfoSchema = exports.olapicInfoSchema = _zod.z.object({
  data: _zod.z.object({
    _embedded: _zod.z.object({
      customer: _zod.z.object({
        id: _zod.z.string().default(''),
        language: _zod.z.string().default('en-GB')
      })
    })
  })
});
